<script>
export default {
	name: 'MenuItem',
	functional: true,
	props: {
		icon: {
			type: String,
			default: ''
		},
		title: {
			type: String,
			default: ''
		}
	},
	render (h, context) {
		const { title } = context.props
		const vnodes = []

		// if (icon) {
		//   vnodes.push(<svg-icon icon-class={icon}/>)
		// }

		if (title) {
			if (title.length > 7) {
				vnodes.push(
					<el-tooltip effect="dark" content={title} placement="right">
						<span>{(title)}</span>
					</el-tooltip>
				)
			} else {
				vnodes.push(<span>{(title)}</span>)
			}
		}
		return vnodes
	}
}
</script>
